export default {
  data() {
    return {
      showNewNaming: this.$ld.has('show-show-builder', false),
    };
  },

  created() {
    this.$ld.on(this.onShowBuilderNamingFlagChange);
  },

  beforeUnmount() {
    this.$ld.off(this.onShowBuilderNamingFlagChange);
  },

  methods: {
    onShowBuilderNamingFlagChange() {
      this.showNewNaming = this.$ld.has('show-show-builder', false);
    },
  },
};
